import { setClientBaseUrl, toolkitClient } from "./client";
import { useQuery } from "react-query";
const loadItemInfo = (ctkToken) => {
  const itemInfoGraphQL = `
  path {
    name
    metadata {
      value
      name
    }
    segments {
      id
      components {
        id
        type
        content {
        id
        contentId
          ... on QuestionItemContent {
          id
          contentId
            objectives {
              content { 
                ... on ObjectiveContent {
                  contentId
                  objective 
                }
              }
            }
          }
        }
        metadata {
          value
          name
        }
      }
    }
  }`;
  const itemInfoQuery = `query {${itemInfoGraphQL}}`;
  return toolkitClient({
    url: "/api/graphql",
    method: "POST",
    headers: {
      Authorization: `Bearer ${ctkToken}`,
      "Content-Type": "application/graphql"
    },
    data: itemInfoQuery
  });
};
function useItemInfoQuery(ctkBaseUrl, ctkToken) {
  setClientBaseUrl(ctkBaseUrl);
  return useQuery(
    ["itemInfo", ctkBaseUrl, ctkToken],
    () => loadItemInfo(ctkToken).catch(() => {
      console.error("Error loading item info");
    }),
    {
      enabled: true,
      refetchOnWindowFocus: false
    }
  );
}
export {
  loadItemInfo,
  useItemInfoQuery
};
